<!-- 用户使用无侧边栏 -->
<template>
  <div class="serve">
    <div class="serveMobile">
      <header>
        <!-- require('@/assets/img/logo2.png') -->
        <img :src="config.icon && config.icon != '' ?  config.icon : 'http://img.spolicy.com/-20250806110920.'">
      </header>
      <main>
        <div class="mainContent" ref="messageContainer2">
          <div v-for="(msg, index) in messages[currentChatId]" :key="index" class="messageBox" :class="[msg.role, { policySummaryMessage: msg.policySummary, thinkingMessage: msg.role !== 'user' && !msg.hasAnswerContent && (msg.loading || msg.reasoningContent) }]">
            <div class="message" :class="{ userMessage: msg.role === 'user' }">
              <div class="messageContent">
                <div class="messageText">
                  <template v-if="msg.role === 'user'">
                    <PolicySummaryQuestion v-if="msg.policySummary" :title="msg.policySummary.title" :preview="msg.policySummary.preview" />
                    <p v-else class="messageP">{{ msg.content }}</p>
                  </template>
                  <template v-else>
                    <transition name="thinking">
                      <div v-if="msg.reasoningContent && !msg.hasAnswerContent" class="thinking-block">
                        <div class="thinking-header">
                          <span class="thinking-icon">&#10022;</span>
                          <span class="thinking-label">{{ msg.loading ? '正在思考' : '思考过程' }}</span>
                          <span v-if="msg.loading" class="thinking-dots"><i></i><i></i><i></i></span>
                        </div>
                        <div class="thinking-body">{{ msg.reasoningContent }}</div>
                      </div>
                    </transition>
                    <div v-html="parseMarkdown(msg.content)"></div>
                    <p v-if="msg.role !== 'user' && index === 0">
                      <span @click="defaultSend(item)" v-for="(item, i) in titleList[chooseTitle].questionList" :key="i"><u></u>{{ item }}</span>
                    </p>
                    <span v-if="msg.loading && !msg.reasoningContent && !msg.hasAnswerContent" class="response-wait" role="status">
                      <span>等待响应中...</span>
                    </span>
                  </template>
                </div>
                <!-- 猜你想问 -->
                <div v-if="msg.role !== 'user' && msg.guessList && msg.guessList.length > 0" class="guessBox">
                  <i @click="defaultSend(res)" v-for="(res, i) in msg.guessList" :key="i">{{ res }}</i>
                </div>
                <!-- 复制按钮 -->
                <div @click="copyText(msg.content)" class="botCopy" v-if="msg.role === 'assistant' && msg.loading == false && index !== 0">
                  <i class="el-icon-copy-document"></i>
                </div>
              </div>
              <div v-if="msg.role !== 'user' && msg.loading" @click="stopMessage" class="messageStop">停止回答</div>
            </div>
          </div>
        </div>
        <div class="mainFooter" :class="{'focused': isFocused}">
          <el-button v-if="config.agent == 'true'" :class=" nowUploadFile ? 'uploadBtn activeUpload' : 'uploadBtn'" @click="handleFileUpload">
            {{ nowUploadFile ? nowUploadFile.name : '➕' }}
            <i v-if="nowUploadFile">❌</i>
          </el-button>
          <el-input :autosize="{ minRows: 1, maxRows: 4 }" type="textarea" @keydown.native="inpSend($event)" @focus="onFocus" @blur="onFocus" placeholder="请输入问题" maxlength="1500" v-model="question" ></el-input>
          <p @click="config.agent == 'true' ? sendDify() : send()" v-if="question.length == 0 && isSending == false"><img src="@/assets/img/nosend.png" alt=""></p>
          <p @click="config.agent == 'true' ? sendDify() : send()" v-else-if="question.length > 0"><img src="@/assets/img/send.png" alt=""></p>
          <p class="stopP" @click="stopMessage" v-else-if="isSending"><i class="el-icon-loading"></i></p>
        </div>
      </main>
      <el-drawer
        title="问答历史"
        :visible.sync="drawer"
        direction="ltr">
        <div class="drawerContent">
          <div class="drawerNav">
            <img src="@/assets/img/logo.png" alt="">
          </div>
          <p>
            <span>最近使用</span>
            <span>更多
              <u>
                <i class="el-icon-arrow-up"></i>
                <i class="el-icon-arrow-down"></i>
              </u>
            </span>
          </p>
          <ul>
            <li
              v-for="(item, index) in titleList"
              :key="index"
              :class="{ active: item.chatId === currentChatId }"
              @click="changeChat(item, index)"
            >
              <img src="@/assets/img/icon.png" alt="">
              <span class="textHidden">{{ item.contentText }}</span>
            </li>
          </ul>
        </div>
      </el-drawer>
    </div>
    <div class="servePC">
      <header>
        <img :src="config.icon && config.icon != '' ? config.icon : require('@/assets/img/logo.png')">
      </header>
      <main>
        <article>
          <div class="artHeader">
            <div class="tip">
              <el-popconfirm icon-color="red"  title="是否清除所有会话?" @confirm="clearCurrentChat">
                <p slot="reference"><img src="@/assets/img/clear.png"><span>清除所有会话</span></p>
              </el-popconfirm>
            </div>
            <div class="artBox" ref="messageContainer">
              <div v-for="(item, index) in messages[currentChatId]" :key="index" :class="[item.role === 'user' ? 'questionBox' : 'answerBox', { policySummaryMessage: item.policySummary, thinkingMessage: item.role !== 'user' && !item.hasAnswerContent && (item.loading || item.reasoningContent) }]">
                <div class="contentBox">
                  <div>
                    <img v-if="item.role !== 'user'" src="@/assets/img/AI.png" alt="">
                    <div class="messageP">
                      <PolicySummaryQuestion v-if="item.policySummary" :title="item.policySummary.title" :preview="item.policySummary.preview" />
                      <template v-else>
                        <transition name="thinking">
                          <div v-if="item.reasoningContent && !item.hasAnswerContent" class="thinking-block">
                            <div class="thinking-header">
                              <span class="thinking-icon">&#10022;</span>
                              <span class="thinking-label">{{ item.loading ? '正在思考' : '思考过程' }}</span>
                              <span v-if="item.loading" class="thinking-dots"><i></i><i></i><i></i></span>
                            </div>
                            <div class="thinking-body">{{ item.reasoningContent }}</div>
                          </div>
                        </transition>
                        <div class="content-text-body" v-html="item.content"></div>
                      </template>
                      <p v-if="item.role !== 'user' && index === 0">
                        <span @click="defaultSend(item)" v-for="(item, i) in titleList[chooseTitle].questionList" :key="i"><u></u>{{ item }}</span>
                      </p>
                      <span v-if="item.loading && item.role !== 'user' && !item.reasoningContent && !item.hasAnswerContent" class="response-wait" role="status">
                        <span>等待响应中...</span>
                      </span>
                      <!-- 猜你想问 -->
                      <div v-if="item.role !== 'user' && item.guessList && item.guessList.length > 0" class="guessBox">
                         <i @click="defaultSend(res)" v-for="(res, i) in item.guessList" :key="i">{{ res }}</i>
                       </div>
                      <span @click="copyText(item.content)" class="botCopy" v-if="item.role === 'assistant' && item.loading == false && index !== 0">
                        <i class="el-icon-copy-document"></i>复制
                      </span>
                    </div>
                    <img v-if="item.role === 'user'" src="@/assets/img/user.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="artFooter">
            <el-button v-if="config.agent == 'true'" :class=" nowUploadFile ? 'uploadBtn activeUpload' : 'uploadBtn'" @click="handleFileUpload">
              {{ nowUploadFile ? nowUploadFile.name : '上传' }}
              <i v-if="nowUploadFile">❌</i>
            </el-button>
            <el-input type="textarea" placeholder="请输入问题（Shift+Enter 换行)" maxlength="1500" v-model="question" ref="textarea"
              @keydown.native="inpSend($event)" @input="resizeTextarea" :autosize="{ minRows: 2, maxRows: 10 }"></el-input>
            <el-button v-if="isSending === false && config.agent == 'false'" @click="send" class="lightBtn">发送</el-button>
            <el-button v-else-if="isSending === false && config.agent == 'true'" @click="sendDify" class="lightBtn">发送</el-button>
            <el-button v-else @click="stopMessage" class="stopBtn">停止</el-button>
          </div>
        </article>
      </main>
      <!-- 配置弹框 -->
      <el-dialog class="configDialog" title="请选择使用方式" :visible.sync="configDialog" :close-on-click-modal="false">
        <div>
          <ul>
            <li @click="chooseDialogBox = 1" :class="chooseDialogBox === 1 ? 'activeLi' : ''"></li>
            <li @click="chooseDialogBox = 2" :class="chooseDialogBox === 2 ? 'activeLi' : ''"></li>
            <li @click="chooseDialogBox = 3" :class="chooseDialogBox === 3 ? 'activeLi' : ''"></li>
          </ul>
          <div class="configContent">
            <p v-if="chooseDialogBox === 1"><span>将下面链接复制到浏览器打开</span><i @click="copyConfig(1)" class="el-icon-copy-document"></i></p>
            <p v-if="chooseDialogBox === 2"><span>复制下面 iframe 加入到你的网站中</span><i @click="copyConfig(2)" class="el-icon-copy-document"></i></p>
            <p v-if="chooseDialogBox === 3"><span>将下面代码加入到你的网站中</span></p>
            <div v-if="chooseDialogBox === 1" class="configMain"><p>http://aq.pogpt.cn?token=填入token&icon=填入图标地址</p></div>
            <div v-if="chooseDialogBox === 2" class="configMain">
              <p>
                <pre style="margin: -20px 0;">
                  <code>
                    &lt;iframe
                      src="http://aq.pogpt.cn?token=填入token&icon=填入图标地址"
                      style="width: 100%; height: 100%;"
                      frameborder="0" 
                      allow="*"
                    /&gt;
                  </code>
                </pre>
              </p>
            </div>
            <div v-if="chooseDialogBox === 3" class="configMain">
              <p>
                <pre style="margin: -20px 0;">
                  <code>
                    &lt;script type="text/javascript"&gt;
                      (function() {
                        var s = document.createElement('script');
                        s.src = 'http://aq.pogpt.cn/embedChatbot.js?_t=' + new Date().getTime();
                        s.id = 'chatbot-iframe';
                        s.setAttribute('data-bot-src', 'http://aq.pogpt.cn?token=填入token&icon=填入图标地址');
                        s.setAttribute('data-default-open', 'false');
                        s.setAttribute('data-drag', 'false');
                        s.setAttribute('data-open-icon', 'data:image/svg+xml;base64,PHN2ZyB0PSIxNjkwNTMyNzg1NjY0IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQxMzIiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48cGF0aCBkPSJNNTEyIDMyQzI0Ny4wNCAzMiAzMiAyMjQgMzIgNDY0QTQxMC4yNCA0MTAuMjQgMCAwIDAgMTcyLjQ4IDc2OEwxNjAgOTY1LjEyYTI1LjI4IDI1LjI4IDAgMCAwIDM5LjA0IDIyLjRsMTY4LTExMkE1MjguNjQgNTI4LjY0IDAgMCAwIDUxMiA4OTZjMjY0Ljk2IDAgNDgwLTE5MiA0ODAtNDMyUzc3Ni45NiAzMiA1MTIgMzJ6IG0yNDQuOCA0MTZsLTM2MS42IDMwMS43NmExMi40OCAxMi40OCAwIDAgMS0xOS44NC0xMi40OGw1OS4yLTIzMy45MmgtMTYwYTEyLjQ4IDEyLjQ4IDAgMCAxLTcuMzYtMjMuMzZsMzYxLjYtMzAxLjc2YTEyLjQ4IDEyLjQ4IDAgMCAxIDE5Ljg0IDEyLjQ4bC01OS4yIDIzMy45MmgxNjBhMTIuNDggMTIuNDggMCAwIDEgOCAyMi4wOHoiIGZpbGw9IiM0ZTgzZmQiIHAtaWQ9IjQxMzMiPjwvcGF0aD48L3N2Zz4=');
                        s.setAttribute('data-close-icon', 'data:image/svg+xml;base64,PHN2ZyB0PSIxNjkwNTM1NDQxNTI2IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjYzNjciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48cGF0aCBkPSJNNTEyIDEwMjRBNTEyIDUxMiAwIDEgMSA1MTIgMGE1MTIgNTEyIDAgMCAxIDAgMTAyNHpNMzA1Ljk1NjU3MSAzNzAuMzk1NDI5TDQ0Ny40ODggNTEyIDMwNS45NTY1NzEgNjUzLjYwNDU3MWE0NS41NjggNDUuNTY4IDAgMSAwIDY0LjQzODg1OCA2NC40Mzg4NThMNTEyIDU3Ni41MTJsMTQxLjYwNDU3MSAxNDEuNTMxNDI5YTQ1LjU2OCA0NS41NjggMCAwIDAgNjQuNDM4ODU4LTY0LjQzODg1OEw1NzYuNTEyIDUxMmwxNDEuNTMxNDI5LTE0MS42MDQ1NzFhNDUuNTY4IDQ1LjU2OCAwIDEgMC02NC40Mzg4NTgtNjQuNDM4ODU4TDUxMiA0NDcuNDg4IDM3MC4zOTU0MjkgMzA1Ljk1NjU3MWE0NS41NjggNDUuNTY4IDAgMCAwLTY0LjQzODg1OCA2NC40Mzg4NTh6IiBmaWxsPSIjNGU4M2ZkIiBwLWlkPSI2MzY4Ij48L3BhdGg+PC9zdmc+');
                        document.body.appendChild(s);
                      })();
                    &lt;/script&gt;
                  </code>
                </pre>
              </p>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked';
import PolicySummaryQuestion from './PolicySummaryQuestion.vue';
export default {
  name: 'HelloWorld',
  components: { PolicySummaryQuestion },
  data() {
    return {
      // 可配置项------------------------
      config: {
        icon: '',
        token: '',
        appId: '',
        agent: false
      },
      // -------------------------------
      isFocused: false, // 输入框是否聚焦
      chooseDialogBox: 1, // 选中的配置方式
      configDialog: false, // 控制新增弹框
      currentChatId: null, // 当前选中的对话框
      question: '',
      messages: {}, // 存储不同对话框的消息
      isLoading: false,
      isSending: false, // 发送状态标识
      isStopped: false, // 停止标识
      abortController: null, // AbortController实例
      chatRequestActive: false, // 包含流式请求的收尾阶段
      clearAfterRequest: false,
      policyChatReady: false,
      policyParentOrigin: '',
      pendingPolicyRequest: null,
      activePolicyRequestId: '',
      policyRequestIds: [],
      chooseTitle: 0, // 选择的历史对话框
      nowUploadFile: null, // 当前上传的文件
      titleList: [
        {
          chatId: Math.floor(Math.random() * 1000000).toString().padStart(6, '0'),
          content: '您好,我是宁波产业政策问答系统,请问有什么可以帮您?',
          // questionList: ['你是谁?', '如何使用这个系统?'],
          contentText: '宁波产业政策问答系统',
        },
        {
          chatId: Math.floor(Math.random() * 1000000).toString().padStart(6, '0'),
          content: '您好,我是宁波产业政策问答系统,请问有什么可以帮您?',
          // questionList: ['详细解答?', '如何使用这个系统?'],
          contentText: '宁波产业政策问答系统',
        },
        {
          chatId: Math.floor(Math.random() * 1000000).toString().padStart(6, '0'),
          content: '您好,我是宁波产业政策问答系统,请问有什么可以帮您?',
          contentText: '宁波产业政策问答系统',
        },
        {
          chatId: Math.floor(Math.random() * 1000000).toString().padStart(6, '0'),
          content: '您好,我是宁波产业政策问答系统,请问有什么可以帮您?',
          contentText: '宁波产业政策问答系统',
        },
      ],
      drawer: false,
    };
  },
  async mounted() {
    // 根据网址链路信息获取参数
    const urlParams = new URLSearchParams(window.location.search);
    const queryParams = {};
    urlParams.forEach((value, key) => {
      queryParams[key] = value;
    })

    // 获取初始聊天内容
    this.config = queryParams
    try {
      const parentUrl = new URL(this.config.parentOrigin || document.referrer);
      if (parentUrl.protocol === 'https:' || parentUrl.protocol === 'http:') {
        this.policyParentOrigin = parentUrl.origin;
      }
    } catch (error) {
      this.policyParentOrigin = '';
    }
    window.addEventListener('message', this.handleParentMessage);
    if (this.titleList.length > 0) {
      this.currentChatId = this.titleList[0].chatId
      const initialized = this.config.agent == 'true'
        ? await this.getDifyDefaultChat(0)
        : await this.getDefaultChat(0);
      if (initialized && !this._isDestroyed && this.config.token && this.policyParentOrigin
        && this.config.policyAutoQuestion === 'true' && window.parent !== window) {
        this.policyChatReady = true;
        window.parent.postMessage({ type: 'POLICY_CHAT_READY' }, this.policyParentOrigin);
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleParentMessage);
    this.pendingPolicyRequest = null;
    if (this.abortController) this.abortController.abort();
  },
  methods: {
    handleParentMessage(event) {
      if (event.source !== window.parent || window.parent === window
        || (this.policyParentOrigin && event.origin !== this.policyParentOrigin)) return;
      if (event.data === 'clearChat') {
        this.cancelPolicyQuestion();
        // 等旧流式请求结束后再清空，防止旧请求改写新会话。
        if (this.chatRequestActive) {
          this.clearAfterRequest = true;
          this.stopMessage();
        } else {
          this.clearCurrentChat();
        }
        return;
      }
      if (!this.policyChatReady || !event.data || typeof event.data !== 'object') return;
      if (event.data.type === 'POLICY_CHAT_CANCEL') {
        this.cancelPolicyQuestion();
        return;
      }
      if (event.data.type !== 'POLICY_CHAT_ASK') return;
      const request = event.data.payload;
      if (!request || !['requestId', 'policyId', 'title', 'content'].every(
        (key) => typeof request[key] === 'string'
      ) || !request.requestId || !request.policyId || !request.content.trim()) return;
      window.parent.postMessage({
        type: 'POLICY_CHAT_ACCEPTED', requestId: request.requestId,
      }, this.policyParentOrigin);
      if (this.policyRequestIds.includes(request.requestId)) return;
      this.policyRequestIds = [...this.policyRequestIds.slice(-99), request.requestId];
      this.pendingPolicyRequest = request;
      if (this.chatRequestActive) {
        this.stopMessage();
      } else {
        this.flushPolicyQuestion();
      }
    },
    cancelPolicyQuestion() {
      this.pendingPolicyRequest = null;
      if (this.activePolicyRequestId && this.chatRequestActive) this.stopMessage();
      this.activePolicyRequestId = '';
    },
    async flushPolicyQuestion() {
      if (this.chatRequestActive || this._isDestroyed) return;
      if (this.clearAfterRequest) {
        this.clearAfterRequest = false;
        this.clearCurrentChat();
      }
      const request = this.pendingPolicyRequest;
      if (!request || !this.policyChatReady) return;
      this.pendingPolicyRequest = null;
      this.clearCurrentChat();
      // 每篇政策独立开启会话，后续追问仍使用这个会话。
      this.currentChatId = `policy-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      this.titleList[this.chooseTitle].chatId = this.currentChatId;
      // 详情自动提问直接展示文章卡片，不插入开场白和推荐问题。
      this.$set(this.messages, this.currentChatId, []);
      this.activePolicyRequestId = request.requestId;
      // 等待新会话更新，并确认期间没有取消或切换政策。
      await this.$nextTick();
      if (this._isDestroyed || this.activePolicyRequestId !== request.requestId) return;
      this.defaultSend(`根据文章，简要提炼核心内容，简述给我\n\n政策标题：${request.title}\n政策内容：${request.content}`, {
        kind: 'policy-summary',
        title: request.title,
        preview: request.content,
      });
    },
    finishChatRequest() {
      this.chatRequestActive = false;
      this.activePolicyRequestId = '';
      this.$nextTick(this.flushPolicyQuestion);
    },
    // 上传文件
    handleFileUpload() {
      if (this.nowUploadFile) {
        this.nowUploadFile = null;
        return false;
      }
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.doc,.docx,.xls,.xlsx'; // 限制文件格式
      input.onchange = this.sendDifyFile;
      input.click();
    },
    resizeTextarea() {
      this.$refs.textarea.$el.style.height = 'auto';
      this.$refs.textarea.$el.style.height = this.$refs.textarea.$el.scrollHeight + 'px';
    },
    onFocus() {
      this.isFocused = !this.isFocused;
    },
    // 获取猜你想问参数
    async getSuggest() {
      const chatId = this.currentChatId;
      const message = this.messages[chatId]?.slice(-1)[0];
      const url = '/api/core/ai/agent/v2/createQuestionGuide'
      const headers = {
        Authorization: 'Bearer fastgpt-' + this.config.token,
        'Content-Type': 'application/json',
      }
      const data = {
        appId: this.config.appId,
        chatId: this.currentChatId,
        // qusetionGuideType: {
        //   open: true,
        //   model: "优策PoPGPT",
        //   customPrompt: "你是一个智能助手，请根据用户的问题生成猜你想问。"
        // },
      }
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data),
        });
        if (!response.ok) {
          throw new Error('网络响应错误');
        }
        const res = await response.json()
        if (this.currentChatId !== chatId || !message) return;
        this.$set(message, 'guessList', res.data)
        this.$forceUpdate()
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    // 获取默认问答
    async getDefaultChat(index) {
      const url = '/api/core/chat/init?chatId=' + this.currentChatId + '&appId=' + this.config.appId + '&_t=' + new Date().getTime();
      const headers = {
        Authorization: 'Bearer fastgpt-' + this.config.token,
        'Content-Type': 'application/json',
      }
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: headers,
        });
        if (!response.ok) {
          throw new Error('网络响应错误');
        }
        const res = await response.json()
        const welcomeText = res.data.app.chatConfig.welcomeText;
        const parsedText = welcomeText.split('\n');
        // 标题
        this.titleList[index].content = parsedText[0]
        // 内容
        this.titleList[index].questionList =  parsedText.slice(1).map(question => question.slice(1, -1))
        // 左侧菜单
        this.titleList[index].contentText = res.data.app.name
        // 设置网站名称
        document.title = res.data.app.name
        // 发起默认会话
        this.changeChat(this.titleList[0], 0)
        return true;
      } catch (error) {
        console.error('请求失败:', error)
        return false;
      }
    },
    copyConfig(index) {
      let textToCopy;
      if (index === 1) {
        textToCopy = 'http://aq.pogpt.cn/'
      } else if (index === 2) {
        textToCopy = '<iframe src="http://aq.pogpt.cn/chat/share?shareId=bjujy3813y2ervirjfh0anf5" style="width: 100%; height: 100%;" frameborder="0" allow="*"></iframe>'
      }
      // 创建一个临时的 textarea 元素用于复制文本
      const textarea = document.createElement('textarea')
      textarea.value = textToCopy
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('复制成功!')
    },
    parseMarkdown(content) {
      return marked(content);
    },
    stopMessage() {
      if (this.isStopped) return;
      if (this.isSending || this.chatRequestActive) {
        this.isStopped = true;
        if (this.abortController) {
          this.abortController.abort();
        }
        const lastMessage = this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1];
        lastMessage.content = lastMessage.content + '<p style="color: red;"> 已停止生成!</p>';
        lastMessage.loading = false;
        this.isSending = false;
      }
    },
    changeChat(result, index) {
      this.chooseTitle = index
      this.currentChatId = result.chatId;
      if (!this.messages[result.chatId]) {
        this.messages[result.chatId] = [];
      }
      if (this.messages[result.chatId].length === 0) {
        // 配置对应的默认回答
        this.messages[result.chatId].push({
          role: 'assistant',
          content: `${result.content}`,
          loading: false,
        })
      }
      this.drawer = false
    },
    clearCurrentChat() {
      if (!this.currentChatId) return false
      // 停止会话
      this.stopMessage()
      // 重新设置chartId
      this.titleList[this.chooseTitle].chatId = Math.floor(Math.random() * 1000000).toString().padStart(6, '0')
      this.currentChatId = this.titleList[this.chooseTitle].chatId
      this.messages = {};
    },
    inpSend(event) {
      if (event.key === 'Enter') {
        if (!event.shiftKey) {
          event.preventDefault();
          if (this.config.agent == 'true') {
            this.sendDify()
          } else {
            this.send()
          }
        }
      }
    },
    // 默认回答
    defaultSend(defaultQuestion, policySummary = null) {
      this.question = defaultQuestion
      if (this.config.agent == 'true') {
        this.sendDify(policySummary)
      } else {
        this.send(policySummary)
      }
    },
    createUserMessage(content, policySummary) {
      const message = { role: 'user', content };
      // 只通过自动提问入口附加展示信息，完整正文仍作为原始提问发送。
      if (policySummary && policySummary.kind === 'policy-summary') {
        message.policySummary = {
          title: policySummary.title,
          preview: policySummary.preview,
        };
      }
      return message;
    },
    // 发送fastgpt会话
    async send(policySummary = null) {
      if (!this.question.trim() || this.isLoading || this.chatRequestActive) return
      if (!this.config.token) {
       return  this.$message.error('请先配置token')
      }
      this.abortController = new AbortController()
      this.isStopped = false
      this.isSending = true
      if (!this.currentChatId) {
        alert('请先选择一个会话或创建新会话')
        return;
      }
      this.chatRequestActive = true;
      if (!this.messages[this.currentChatId]) {
        this.messages[this.currentChatId] = [];
      }
      this.messages[this.currentChatId].push(this.createUserMessage(this.question, policySummary));
      this.messages[this.currentChatId].push({
        role: 'assistant',
        content: '',
        loading: true,
        reasoningContent: '',
        hasAnswerContent: false,
      });
      this.scrollToBottom()
      this.isLoading = true;
      const userMessage = this.question;
      this.question = '';
      const url = '/api/v1/chat/completions';
      const headers = {
        Authorization: 'Bearer fastgpt-' + this.config.token,
        'Content-Type': 'application/json',
      };
      const data = {
        stream: true,
        chatId: this.currentChatId,
        messages: [{ role: 'user', content: userMessage }],
      }
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data),
          signal: this.abortController.signal,
        });
        if (!response.ok) {
          throw new Error('网络响应错误');
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let lastMessage = this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1];
        let markdownContent = ''; // 累积完整的 Markdown 内容
        // eslint-disable-next-line no-constant-condition
        while (true) {
          if (this.isStopped) break;
          const { done, value } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value);
          const lines = chunk.split('\n').filter((line) => line.trim());
          for (const line of lines) {
            if (line.startsWith('data: ')) {
              const dataStr = line.slice(6);
              if (dataStr === '[DONE]') {
                lastMessage.loading = false;
                break;
              }
              if (this.isStopped) break;
              try {
                const parsedData = JSON.parse(dataStr);
                const reasoningChunk = parsedData.reasoning_content
                  || parsedData.delta?.reasoning_content
                  || parsedData.choices?.[0]?.delta?.reasoning_content;
                if (!lastMessage.hasAnswerContent && typeof reasoningChunk === 'string' && reasoningChunk) {
                  this.$set(lastMessage, 'reasoningContent', lastMessage.reasoningContent + reasoningChunk);
                  this.scrollToBottom();
                }
                const content = parsedData.choices[0]?.delta?.content || '';
                if (content) this.$set(lastMessage, 'hasAnswerContent', true);
                markdownContent += content; // 累积 Markdown 内容
                // 使用 marked 库将 markdown 转换为 html
                const htmlContent = marked(markdownContent);
                this.$set(lastMessage, 'content', htmlContent)
                this.$forceUpdate()
                this.scrollToBottom()
              } catch (e) {
                console.error('解析数据错误:', e);
              }
            }
          }
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('请求已被中止');
        } else {
          console.error('请求失败:', error);
          this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].content = '发生错误，请重试';
          this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].loading = false;
        }
      } finally {
        this.isLoading = false;
        this.isSending = false;
        this.abortController = null;
        if (!this.isStopped) this.getSuggest();
        this.finishChatRequest();
      }
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer
        if (container) {
          container.scrollTop = container.scrollHeight
        }
        const container2 = this.$refs.messageContainer2
        if (container) {
          container2.scrollTop = container2.scrollHeight
        }
      })
    },
    copyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text || this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].content;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success('复制成功')
    },
    // --------------------- dify配置 ----------
    // dify上传文件处理
    async sendDifyFile(event) {
      const file = event.target.files[0];
      if (!file) return;
      const formData = new FormData();
      formData.append('user', this.currentChatId);
      formData.append('file', file);
      const url = '/defaultDifyApi/v1/files/upload';
      const headers = {
        Authorization: 'Bearer ' + this.config.token,
      };
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: formData,
        });
        if (!response.ok) {
          throw new Error('文件上传失败');
        }
        const res = await response.json();
        this.nowUploadFile = res
        this.scrollToBottom();
      } catch (error) {
        this.$message.error('文件上传失败: ' + error.message);
      }
    },
    // 获取dify默认问答
    async getDifyDefaultChat(index) {
      const url = '/defaultDifyApi/v1/parameters?_t=' + new Date().getTime();
      const headers = {
        Authorization: 'Bearer ' + this.config.token,
        'Content-Type': 'application/json',
      }
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: headers,
        });
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`网络响应错误: ${response.status} - ${errorText}`);
        }
        const res = await response.json()
        console.log('响应数据:', res);
        // 获取开场白
        const openingStatement = res.opening_statement || '您好，我是AI助手，请问有什么可以帮您？';
        // // 设置为默认问答内容
        this.titleList[index].content = openingStatement;
        // 左侧菜单
        this.titleList[index].contentText = res.data?.app?.name
        // 设置网站名称
        // document.title = res.data?.app?.name
        // 发起默认会话
        this.changeChat(this.titleList[0], 0)
        return true;
      } catch (error) {
        console.error('请求失败:', error);
        this.$message.error('获取配置失败: ' + error.message);
        return false;
      }
    },
    // 发送dify会话
    async sendDify(policySummary = null) {
      if (!this.question.trim() || this.isLoading || this.chatRequestActive) return
      if (!this.config.token) {
       return  this.$message.error('请先配置token')
      }
      this.abortController = new AbortController()
      this.isStopped = false
      this.isSending = true
      if (!this.currentChatId) {
        alert('请先选择一个会话或创建新会话')
        return;
      }
      this.chatRequestActive = true;
      if (!this.messages[this.currentChatId]) {
        this.messages[this.currentChatId] = [];
      }
      this.messages[this.currentChatId].push(this.createUserMessage(this.question, policySummary));
      this.messages[this.currentChatId].push({
        role: 'assistant',
        content: '',
        loading: true,
        reasoningContent: '',
        hasAnswerContent: false,
      });
      this.scrollToBottom()
      this.isLoading = true;
      const userMessage = this.question;
      this.question = '';
      const url = '/streamDifyApi/v1/chat-messages';
      const headers = {
        Authorization: 'Bearer ' + this.config.token,
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Connection': 'keep-alive',
        'X-Requested-With': 'XMLHttpRequest'
      };
      const data = {
        conversation_id: '',
        inputs: {},
        query: userMessage,
        response_mode: 'streaming',
        user: this.currentChatId,
        auto_generate_name: true,
        files: [],
      }
      // 如果存在nowUploadFile 则附带上传的文件
      if (this.nowUploadFile) {
        data.files.push({
          // type: this.nowUploadFile.mime_type ? (this.nowUploadFile.mime_type).split('/')[0] : 'file',
          type: 'document',
          transfer_method: "local_file",
          upload_file_id: this.nowUploadFile.id,
          url: ''
        })
      }
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            ...headers,
            // 确保流式传输的头部
            'Accept': 'text/event-stream',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Connection': 'keep-alive'
          },
          body: JSON.stringify(data),
          signal: this.abortController.signal,
          // 禁用缓存
          cache: 'no-store',
          // 确保流式传输
          keepalive: false
        });
        if (!response.ok) {
          throw new Error('网络响应错误');
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let lastMessage = this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1];
        let markdownContent = ''; // 累积完整的 Markdown 内容
        let buffer = ''; // 用于处理不完整的数据块
        
        // eslint-disable-next-line no-constant-condition
        while (true) {
          if (this.isStopped) break;
          const { done, value } = await reader.read();
          if (done) break;
          // 将新数据添加到缓冲区
          buffer += decoder.decode(value, { stream: true });
          // 按行分割数据
          const lines = buffer.split('\n');
          // 保留最后一个可能不完整的行
          buffer = lines.pop() || '';
          for (const line of lines) {
            if (line.trim() === '') continue;
            if (line.startsWith('data: ')) {
              const dataStr = line.slice(6).trim();
              if (dataStr === '[DONE]') {
                lastMessage.loading = false;
                break;
              }
              if (this.isStopped) break;
              try {
                const parsedData = JSON.parse(dataStr);
                // 保存任务ID用于停止响应
                const reasoningChunk = parsedData.reasoning_content
                  || parsedData.delta?.reasoning_content
                  || parsedData.choices?.[0]?.delta?.reasoning_content;
                if (!lastMessage.hasAnswerContent && typeof reasoningChunk === 'string' && reasoningChunk) {
                  this.$set(lastMessage, 'reasoningContent', lastMessage.reasoningContent + reasoningChunk);
                  this.scrollToBottom();
                }
                if (parsedData.task_id && !this.currentTaskId) {
                  this.currentTaskId = parsedData.task_id;
                }
                // 提前清空上传文件
                this.nowUploadFile = null;
                if (parsedData.event === 'message') {
                  // 立即更新UI，确保每个字符都能显示
                  const content = parsedData.answer || '';
                  if (content) {
                    this.$set(lastMessage, 'hasAnswerContent', true);
                    markdownContent += content;
                    // 使用Vue的响应式更新
                    const htmlContent = marked(markdownContent);
                    this.$set(lastMessage, 'content', htmlContent);
                    // 强制更新视图
                    this.$forceUpdate();
                    this.scrollToBottom();
                  }
                  // 保存conversation_id用于后续对话
                  if (parsedData.conversation_id && !this.savedConversationId) {
                    this.savedConversationId = parsedData.conversation_id;
                  }
                } else if (parsedData.event === 'message_end') {
                  lastMessage.loading = false;
                  this.isLoading = false;
                  this.isSending = false;
                  // 获取建议问题
                  if (parsedData.message_id) {
                    this.getSuggestedQuestions(parsedData.message_id);
                  }
                }
              } catch (e) {
                console.error('解析数据错误:', e, '原始数据:', dataStr);
              }
            }
          }
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('请求已被中止');
        } else {
          console.error('请求失败:', error);
          this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].content = '发生错误，请重试';
          this.messages[this.currentChatId][this.messages[this.currentChatId].length - 1].loading = false;
        }
      } finally {
        this.isLoading = false;
        this.isSending = false;
        this.abortController = null;
        this.finishChatRequest();
      }
    },
    // 获取建议问题列表
    async getSuggestedQuestions(messageId) {
      if (!messageId) return;
      const chatId = this.currentChatId;
      const message = this.messages[chatId]?.slice(-1)[0];
      // 使用currentChatId作为user参数
      const url = `/defaultDifyApi/v1/messages/${messageId}/suggested?user=${this.currentChatId}`;
      const headers = {
        Authorization: 'Bearer ' + this.config.token,
        'Content-Type': 'application/json',
      };
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: headers
        });
        if (!response.ok) {
          throw new Error('获取建议问题失败');
        }
        const res = await response.json();
        if (this.currentChatId !== chatId || !message) return;
        if (res.result === 'success' && res.data && res.data.length > 0) {
          this.$set(message, 'guessList', res.data);
          this.$forceUpdate();
        }
      } catch (error) {
        console.error('获取建议问题失败:', error);
      }
    },
  },
};
</script>

<style scoped lang="less">
// 自动提炼用紧凑卡片替代普通用户气泡，桌面与嵌入弹窗共用。
.serve .serveMobile main .mainContent .messageBox.policySummaryMessage {
  margin: 0 0 .625rem;
  .message {
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    box-shadow: none;
    .messageContent {
      width: 100%;
      min-width: 0;
    }
  }
}
.serve .servePC main article .artHeader .artBox .questionBox.policySummaryMessage {
  .contentBox > div {
    width: 100%;
    max-width: 560px;
    margin-left: auto;
    .messageP {
      flex: 1;
      min-width: 0;
      padding: 0;
      border: 0;
      background: transparent;
      box-shadow: none;
    }
  }
}
.serve {
  @media screen and (max-width: 900px) {
    .serveMobile {
      display: block;
      padding: .625rem 0;
      width: 100%;
      height: 100vh;
      background: linear-gradient(90deg, rgb(73, 125, 238), #8ba8fe 46%, rgb(73, 125, 238));
      background-size: 100% 100%;
      box-sizing: border-box;
      border: .125rem solid rgb(73, 125, 238);
      border-radius: .5rem;
      header {
        position: relative;
        padding: 0 .625rem 0.625rem;
        display: flex;
        align-items: center;
        height: 2rem;
        >img {
          height: 2.6rem;
          max-width: calc(100% - 7.5rem);
        }
        // .clearBtn {
        //   position: absolute;
        //   top: 0;
        //   right: 85px;
        //   height: 2rem;
        //   cursor: pointer;
        // }
      }
      main {
        display: flex;
        flex-direction: column;
        padding: .625rem .5rem;
        height: calc(100vh - 4.81rem);
        background: linear-gradient( 146deg, #F2F6FE 0%, #FAF7FF 100%);
        border-radius: .5rem;
        .mainContent {
          flex: 1;
          overflow: auto;
          .messageBox {
            display: flex;
            margin: .625rem 0;
            .message {
              position: relative;
              margin-left: .125rem;
              padding: .625rem;
              border-radius: 0 .5rem .5rem .5rem;
              background-color: #fff;
              border: .0625rem solid rgb(228, 231, 237);
              box-shadow: rgba(31, 35, 41, 0.12) 0 .085rem .25rem;
              .messageContent {
                .messageText {
                  text-align: left;
                  color: #333;
                  font-weight: 500;
                  font-size: 1.1rem;
                  p {
                    white-space: pre-wrap!important;
                    span {
                      margin-top: 0.1rem;
                      display: flex;
                      align-items: center;
                      cursor: pointer;
                      color: #333;
                      font-size: 1.1rem;
                      line-height: 1.8rem;
                      u {
                        margin-right: 0.4rem;
                        display: inline-block;
                        height: 0.4rem;
                        width: 0.4rem;
                        border-radius: 50%;
                        background-color: #333;
                      }
                    }
                  }
                }
                .guessBox {
                  display: flex;
                  flex-wrap: wrap;
                  i {
                    margin: .3rem 1rem .3rem 0;
                    padding: .3rem .6rem;
                    box-sizing: border-box;
                    border-radius: .2rem;
                    border: .075rem solid rgb(225, 226, 229);
                    cursor: pointer;
                    font-size: 1rem;
                    font-weight: 500;
                    line-height: 1.2rem;
                    color: rgba(51, 51, 51);
                    z-index: 10;
                  }
                  i:hover {
                    border-color: #3370ff;
                    color: #3370ff;
                  }
                  i:nth-child(3) {
                    margin-right: 0;
                  }
                }
              }
              .messageStop {
                position: absolute;
                bottom: -1.7rem;
                left: 0.4rem;
                width: 5rem;
                cursor: pointer;
                text-align: left;
                color: #8ba8fe;
                font-weight: bold;
                font-size: 1rem;
                z-index: 10;
              }
              .messageStop:hover {
                color: #5e84f5;
              }
            }
            
            .userMessage {
              margin-right: .125rem;
              border-radius: .5rem 0 .5rem .5rem;
              background: linear-gradient(90deg, rgb(73, 125, 238), #8ba8fe 46%, #8ba8fe 48%, rgb(73, 125, 238));
              border: .0625rem solid rgb(73, 125, 238);
              box-shadow: 0;
              .messageContent {
                .messageText {
                  text-align: left;
                  color: #fff;
                }
              }
            }
            .loadingDots, .loadingDots2, .loadingDots3 {
              margin-right: .3125rem;
              display: inline-block;
              width: .3125rem;
              height: .3125rem;
              background-color: #000;
              border-radius: 50%;
              animation: loading 0.8s infinite ease-in-out;
            }
            .loadingDots2 {
              animation: loading2 0.8s infinite ease-in-out;
            }
            .loadingDots3 {
              animation: loading3 0.8s infinite ease-in-out;
            }
            @keyframes loading {
              0% { transform: scale(1.5); }
              50% { transform: scale(1); }
              100% { transform: scale(1); }
            }
            @keyframes loading2 {
              0% { transform: scale(1); }
              50% { transform: scale(1.5); }
              100% { transform: scale(1); }
            }
            @keyframes loading3 {
              0% { transform: scale(1); }
              50% { transform: scale(1); }
              100% { transform: scale(1.5); }
            }
            .botCopy {
              margin-top: .3125rem;
              width: 1.25rem;
              cursor: pointer;
              color: rgb(73, 125, 238);
              z-index: 10;
            }
          }
          .user {
            justify-content: right;
          }
        }
        .mainFooter.focused {
          border: .0625rem solid rgb(73, 125, 238)!important;
        }
        .mainFooter {
          position: relative;
          margin-top: 0.5rem;
          padding: 0 0.25rem;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          min-height: 2.85rem;
          background-color: #fff;
          border-radius: 0.6rem;
          box-sizing: border-box;
          box-shadow: 0 .375rem 1.5rem #1f232914;
          border: .0625rem solid #fff;
          .uploadBtn {
            margin: .5625rem .1875rem;
            padding: 0 .5rem;
            ::v-deep span {
              white-space: nowrap!important;
            }
            i {
              font-size: .5625rem;
            }
          }
          .uploadBtn:hover {
            background-color: rgba(172, 185, 250, .5);
            border: .0625rem solid rgb(73, 125, 238);
          }
          .activeUpload {
            background-color: rgba(172, 185, 250, .5);
            border: .0625rem solid rgb(73, 125, 238);
            color: rgb(73, 125, 238);
          }
          /deep/ .el-textarea {
            .el-textarea__inner {
              padding: .8125rem .625rem;
              font-size: 1rem;
              border: none!important;
              resize: none;
            }
            .el-textarea__inner:focus {
              border-color: #007bff!important;
            }
          }
          p {
            margin: 0 .5rem .7rem;
            width: 1.8rem;
            height: 1.8rem;
            border-radius: 50%;
            background-color: #fff;
            text-align: center;
            cursor: pointer;
            overflow: hidden;
            img {
              width: 1.8rem;
              height: 1.8rem;
            }
            i {
              color: #333;
              font-size: 1rem;
            }
          }
          .stopP {
            display: block;
            border: 0;
          }
        }
        .mainFooter::before {
          position: absolute;
          top: -2rem;
          left: 0;
          content: '';
          width: 100%;
          height: 1.5rem;
          background: linear-gradient(0deg,#f3f7f9 0%,rgba(243,247,249,0) 100%);
        }
      }
    }
    /deep/ .el-drawer {
      width: 80%!important;
      .el-drawer__header {
        display: none;
      }
      .drawerContent {
        padding: 1rem 1.5rem;
        background-color: #fff;
        box-sizing: border-box;
        .drawerNav {
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          height: 2rem;
          width: calc(100%);
          background-color: #eee;
          border-radius: 0.2rem;
          img {
            margin-left: 0.5rem;
            height: 1.5rem;
          }
        }
        >p {
          margin-bottom: 1.1875rem;
          padding: 0 0 .3125rem;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #eee;
          font-size: .8125rem;
          color: #333333;
          font-weight: bold;
          span:nth-child(1) {
            margin-left: .3125rem;
          }
          span:nth-child(2) {
            display: flex;
            align-items: center;
            u {
              margin-left: .125rem;
              display: flex;
              align-items: center;
              flex-direction: column;
              text-decoration:none;
              i {
                cursor: pointer;
                font-size: .6875rem;
                font-weight: 500;
              }
              i:hover {
                color: #5093F2;
              }
            }
          }
        }
        ul {
          height: calc(100vh - 10rem);
          overflow: auto;
          li {
            padding: 0 .75rem;
            display: flex;
            align-items: center;
            height: 2.2rem;
            width: 100%;
            box-sizing: border-box;
            border-radius: .25rem;
            cursor: pointer;
            text-align: left;
            font-size: .8125rem;
            font-weight: bold;
            img {
              margin-right: .3rem;
              width: .75rem;
              height: .75rem;
            }
            span {
              height: 1rem;
              line-height: 1rem;
            }
          }
          li:hover {
            background-color: #EFF6FF;
            color: #5093F2;
          }
          .active {
            background-color: #EFF6FF;
            color: #5093F2;
          }
        }
      }
    }
    .servePC {
      display: none;
    }
  }
  @media screen and (min-width: 901px) {
    .serveMobile {
      display: none;
    }
    .servePC {
      display: block;
      padding: 20px 38.5px 32.5px;
      width: 100%;
      height: 100vh;
      background: url('https://img.spolicy.com/FtPX4f7y1ShOfSJMu8XLifprgUyB') no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      header {
        margin-bottom: 22px;
        display: flex;
        align-items: center;
        height: 46px;
        img {
          margin: 0 15px 0 27px;
          height: 46px;
        }
      }
      main {
        display: flex;
        justify-content: space-between;
        height: calc(100vh - 120px);
        background-color: #fff;
        border-radius: 40px;
        overflow: hidden;
        aside {
          padding: 22px 36px;
          width: 318px;
          background-color: #fff;
          box-sizing: border-box;
          >p {
            margin-bottom: 19px;
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            color: #333333;
            font-weight: bold;
            span:nth-child(1) {
              margin-left: 5px;
            }
            span:nth-child(2) {
              display: flex;
              align-items: center;
              u {
                margin-left: 2px;
                display: flex;
                align-items: center;
                flex-direction: column;
                text-decoration:none;
                i {
                  cursor: pointer;
                  font-size: 10px;
                  font-weight: bold;
                }
                i:hover {
                  color: #5093F2;
                }
              }
            }
          }
          ul {
            height: calc(100vh - 260px);
            width: 246px;
            overflow: auto;
            li {
              padding: 10px 25px;
              display: flex;
              align-items: center;
              height: 38px;
              box-sizing: border-box;
              border-radius: 4px;
              cursor: pointer;
              text-align: left;
              font-size: 14px;
              font-weight: bold;
              img {
                margin-right: 3px;
                width: 14px;
                height: 14px;
              }
              span {
                height: 15px;
                line-height: 14px;
              }
            }
            li:hover {
              background-color: #EFF6FF;
              color: #5093F2;
            }
            .active {
              background-color: #EFF6FF;
              color: #5093F2;
            }
          }
          .setFooter {
            width: 100%;
            height: 22px;
            background-color: rgb(246, 246, 254);
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            line-height: 22px;
            font-weight: bold;
            color: #333;
          }
          .setFooter:hover {
            color: #007bff;
            background-color: #EFF6FF;
          }
        }
        article {
          flex: 1;
          display: flex;
          flex-direction: column;
          height: 100%;
          background: linear-gradient( 146deg, #F2F6FE 0%, #FAF7FF 100%);
          .artHeader {
            flex: 1;
            background: linear-gradient( 146deg, #F2F6FE 0%, #FAF7FF 100%);
            .tip  {
              margin: 20px 30px 0 7px;
              display: flex;
              justify-content: right;
              align-items: center;
              height: 32px;
              border-bottom: 1px dotted #CBD5E6;
              text-align: right;
              line-height: 62px;
              font-size: 13px;
              font-weight: bold;
              color: #555555;
              p {
                display: flex;
                align-items: center;
                img {
                  margin-right: 5px;
                  width: 18px;
                  height: 18px;
                  cursor: pointer;
                }
                span {
                  margin-top: 2px;
                  cursor: pointer;
                  font-size: 14px;
                }
              }
            }
            .tip:hover {
              color: #5093F2;
            }
            .artBox {
              padding: 30px;
              height: calc(100vh - 333px);
              overflow: auto;
              .questionBox {
                margin-bottom: 24px;
                .contentBox {
                  width: 100%;
                  span {
                    display: block;
                    font-size: 12px;
                    font-weight: bold;
                    color: #ccc;
                  }
                  >div {
                    margin-left: 30%;
                    display: flex;
                    justify-content: right;
                    align-items: center;
                    width: 70%;
                    .messageP {
                      padding: 10px 15px;
                      background: #4887F9;
                      border-radius: 12px 12px 0px 12px;
                      border: .0625rem solid rgb(228, 231, 237);
                      box-shadow: rgba(31, 35, 41, 0.12) 0 .085rem .25rem;
                      line-height: 25px;
                      font-size: 15px;
                      font-weight: bold;
                      color: #fff;
                      text-align: left;
                    }
                    img {
                      margin-left: 10px;
                      width: 43px;
                      height: 43px
                    }
                  }
                }
              }
              .answerBox {
                margin-bottom: 24px;
                .contentBox {
                  width: 100%;
                  span {
                    display: block;
                    font-size: 14px;
                    font-weight: bold;
                    color: #ccc;
                  }
                  >div {
                    display: flex;
                    justify-content: left;
                    align-items: top;
                    width: 70%;
                    .messageP {
                      padding: 10px 15px;
                      background: #fff;
                      border-radius: 12px 12px 12px 0px;
                      border: .0625rem solid rgb(228, 231, 237);
                      box-shadow: rgba(31, 35, 41, 0.12) 0 .085rem .25rem;
                      line-height: 25px;
                      font-size: 15px;
                      font-weight: bold;
                      color: rgb(51, 51, 51);
                      text-align: left;
                      li {
                        margin-bottom: 16px;
                      }
                      p {
                        span {
                          display: flex;
                          align-items: center;
                          cursor: pointer;
                          color: #333;
                          font-weight: bold;
                          u {
                            margin-right: 6px;
                            display: inline-block;
                            width: 6px;
                            height: 6px;
                            border-radius: 50%;
                            background-color: #333;
                          } 
                        }
                        span:hover {
                          color: #4887F9;
                          u {
                            background-color: #4887F9;
                          }
                        }
                      }
                      .guessBox {
                        display: flex;
                        flex-wrap: wrap;
                        i {
                          margin: 4px 12px 4px 0;
                          padding: 6px 15px;
                          box-sizing: border-box;
                          border-radius: 30px;
                          border: 1px solid rgb(225, 226, 229);
                          cursor: pointer;
                          font-size: 12px;
                          line-height: 12px;
                          color: rgba(51, 51, 51);
                        }
                        i:hover {
                          border-color: rgb(76, 136, 246);
                          color: rgb(76, 136, 246);
                        }
                      }
                      >span {
                        display: inline-block;
                      }
                      .botCopy {
                        margin-top: 6px;
                        display: block;
                        width: 60px;
                        cursor: pointer;
                        color: #333;
                        i {
                          margin-right: 2px;
                          display: inline-block;
                        }
                      }
                      .botCopy:hover {
                        color: #007bff;
                      }
                    }
                    img {
                      margin-right: 10px;
                      width: 43px;
                      height: 43px
                    }
                  }
                }
              }
              .loadingDots, .loadingDots2, .loadingDots3 {
                margin-right: 6px;
                width: 6px;
                height: 6px;
                background-color: #000;
                border-radius: 50%;
                animation: loading 0.8s infinite ease-in-out;
              }
              .loadingDots2 {
                animation: loading2 0.8s infinite ease-in-out;
              }
              .loadingDots3 {
                animation: loading3 0.8s infinite ease-in-out;
              }
              @keyframes loading {
                0% { transform: scale(1.5); }
                50% { transform: scale(1); }
                100% { transform: scale(1); }
              }
              @keyframes loading2 {
                0% { transform: scale(1); }
                50% { transform: scale(1.5); }
                100% { transform: scale(1); }
              }
              @keyframes loading3 {
                0% { transform: scale(1); }
                50% { transform: scale(1); }
                100% { transform: scale(1.5); }
              }
            }
          }
          .artFooter {
            margin-left: 1px;
            padding: 20px 20px;
            display: flex;
            align-items: center;
            min-height: 86px;
            box-sizing: border-box;
            background-color: #fff;
            box-shadow: rgba(31, 35, 41, 0.12) 0 .085rem .25rem;
            .uploadBtn {
              padding: 0 18px;
              height: 58px;
              border-bottom-left-radius: 18px;
              font-weight: bold;
              font-size: 16px;
              color: rgba(0, 0, 0, 0.6);
              ::v-deep span {
                white-space: nowrap!important;
              }
              i {
                font-size: 12px;
              }
            }
            .uploadBtn:hover {
              background: linear-gradient( 180deg, rgba(100, 184, 255, .7) 0%, rgba(72, 119, 249, .7) 100%);
              color: #fff;
            }
            .activeUpload {
              background: linear-gradient( 180deg, rgb(100, 184, 255) 0%, rgb(72, 119, 249) 100%);
              color: #fff;
            }
            /deep/ .el-textarea__inner {
              max-height: 47px;
              max-height: 123px;
              border: 0;
              resize: none;
              overflow-y: auto;
              font-size: 16px;
            }
            .lightBtn {
              // margin-left: 100%;
              // transform: translateX(-50% - 50px);
              width: 113px;
              height: 47px;
              background: linear-gradient( 180deg, rgb(100, 184, 255) 0%, rgb(72, 119, 249) 100%);
              border-radius: 24px 24px 24px 24px;
              font-size: 21px;
              font-weight: 500;
              // font-family: "SourceHanSancCN", "PingFang SC", "Microsoft YaHei", tahoma, system-ui, arial;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #fff;
            }
            .lightBtn:hover {
              background: linear-gradient( 180deg, rgba(100, 184, 255, .8) 0%, rgb(72, 119, 249, .1) 100%);
            }
            .stopBtn {
              width: 113px;
              height: 47px;
              background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(220, 220, 220, 0.1) 100%);
              border-radius: 24px 24px 24px 24px;
              font-size: 21px;
              font-weight: 500;
              // font-family: "SourceHanSancCN", "PingFang SC", "Microsoft YaHei", tahoma, system-ui, arial;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #333; /* 按钮文字颜色设置为黑色 */
            }

            .stopBtn:hover {
              background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(220, 220, 220, 0.3) 100%);
            }
          }
        }
      }
      /deep/ .configDialog {
        .el-dialog {
          width: 700px;
          border-radius: 8px;
          .el-dialog__header {
            padding: 12px 16px 12px;
            vertical-align: top;
            border-radius: 10px;
            background-color: rgb(251, 251, 252);
            font-weight: bold;
            text-align: left;
            .el-dialog__headerbtn {
              top: 16px;
            }
            .el-dialog__title {
              font-size: 16px;
              font-weight: bold;
            }
          }
          .el-dialog__body {
            padding: 16px 28px;
            width: 100%;
            box-sizing: border-box;
            ul {
              display: flex;
              justify-content: space-between;
              li {
                width: 207px;
                height: 118px;
                cursor: pointer;
                border-radius: 8px;
                background-color: #eee;
                border: 1px solid #eee;
                background-image: url('@/assets/img/1.png');
                background-size: cover;
                background-position: center;
              }
              li:nth-child(2) {
                background-image: url('@/assets/img/2.png');
              }
              li:nth-child(3) {
                background-image: url('@/assets/img/3.png');
              }
              li:hover {
                border: 1px solid #007bff;
              }
              .activeLi {
                border: 1px solid #007bff;
              }
            }
            .configContent{
              margin-top: 32px;
              width: 100%;
              overflow: hidden;
              >p {
                padding: 0 12px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 45px;
                box-sizing: border-box;
                background-color: rgb(246, 248, 249);
                border: 1px solid rgb(223, 226, 234);
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
                line-height: 45px;
                text-align: left;
                color: rgb(72, 82, 100);
                font-weight: bold;
                font-size: 14px;
                i {
                  font-size: 14px;
                  font-weight: bold;
                  cursor: pointer;
                }
                i:hover {
                  color: #007bff;
                }
              }
              .configMain {
                padding: 12px;
                box-sizing: border-box;
                background-color: rgb(244, 244, 247);
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
                >p {
                  font-size: 14x;
                  font-weight: 500;
                  text-align: left;
                  overflow-y: hidden;
                  code {
                    // font-family: "SourceHanSancCN", "PingFang SC", "Microsoft YaHei", tahoma, system-ui, arial, "Hiragino Sans GB", sans-serif;
                    font-family: PingFangSC-Regular, PingFang SC;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.thinking-block {
  position: relative;
  margin-bottom: 10px;
  max-height: 240px;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(240, 244, 255, 0.6);
  border: 1px solid rgba(111, 143, 201, 0.24);
  box-shadow: 0 2px 8px rgba(45, 71, 112, 0.08);
  overflow: hidden;
}

.thinking-leave-active {
  transition: max-height .28s ease, opacity .22s ease, transform .28s ease,
    margin-bottom .28s ease, padding .28s ease, border-width .28s ease;
}

.thinking-leave-to {
  max-height: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
  border-top-width: 0;
  border-bottom-width: 0;
  opacity: 0;
  transform: translateY(-5px);
}

.thinking-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.thinking-icon {
  display: inline-block;
  color: rgba(72, 135, 249, 0.7);
  font-size: 11px;
  animation: thinking-spin 4s linear infinite;
}

.thinking-label {
  color: rgba(100, 116, 150, 0.85);
  font-size: 12px;
  font-weight: 600;
}

.thinking-dots {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 2px;
}

.thinking-dots i {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(72, 135, 249, 0.5);
  animation: thinking-dot-bounce 1.2s ease-in-out infinite;
}

.thinking-dots i:nth-child(1) { animation-delay: 0s; }
.thinking-dots i:nth-child(2) { animation-delay: 0.2s; }
.thinking-dots i:nth-child(3) { animation-delay: 0.4s; }

.thinking-body {
  max-height: 5.1em;
  overflow-y: hidden;
  color: rgba(90, 105, 140, 0.75);
  font-size: 12px;
  line-height: 1.7;
  overflow-wrap: break-word;
  word-break: break-all;
}

.response-wait {
  display: flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;
  margin: 4px 0 0;
  padding: 10px 14px;
  border: 1px solid rgb(228, 231, 237);
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 7px rgba(31, 35, 41, 0.1);
  color: #71809a;
  font-size: 12px;
  line-height: 20px;
}

.response-wait > span {
  color: #71809a;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}

.content-text-body {
  display: block;
  overflow-wrap: break-word;
  word-break: break-all;
}

.serve .serveMobile main .mainContent .messageBox.thinkingMessage .message {
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.serve .servePC main article .artHeader .artBox .answerBox.thinkingMessage .contentBox > div .messageP {
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

@keyframes thinking-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes thinking-dot-bounce {
  0%, 80%, 100% { transform: translateY(0); opacity: 0.5; }
  40% { transform: translateY(-4px); opacity: 1; }
}
</style>
